import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createShippingPartner = createAction(ACTION.CREATE_SHIPPING_PARTNER.REQUEST, data => data);
